import React, { useContext } from 'react';
import styled from 'styled-components';
import { WidgetHeader, AgGridWidgetWrapper } from '@mummssoftware/common-ui';
import { AppContext } from '../../context';
import { EventCalendar } from '../../calendar/components/EventCalendar';
import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

const Container = styled.div`
  margin-left: var(--safe-area-inset-left);
  margin-right: var(--safe-area-inset-right);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const WidgetBody = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

type ScheduledVisitProps = {
  currentUser: mumms.User;
  patient: mumms.patient;
  view?: string | null;
  embedded?: boolean;
  appTitle?: string;
  online: boolean;
  /* DASHBOARD- smallWidget mode (NEEDED bc when dashboard in XS mode problem with width calc */
  onClick?: () => void;
  smallWidget?: boolean;
} & typeof RouteProps;

export const ScheduledVisitComponent = ({ onClick }: ScheduledVisitProps) => {
  const { appTitle, smallWidget, onRemove, doNotShow } = useContext(AppContext);

  return (
    <Container>
      <WidgetHeader
        appTitle={appTitle || 'Scheduled Visits'}
        versionInfo={`Scheduled Visits v${process.env.REACT_APP_SCHEDULED_VISITS_VERSION}, SmartChart v${process.env.REACT_APP_VERSION}`}
        onClick={() => onClick && onClick()}
        onRemove={onRemove}
        doNotShow={doNotShow}
        smallWidget={smallWidget}
      />
      <AgGridWidgetWrapper
        id="scheduled-visit-body"
        smallWidget={smallWidget}
        heightOffset={20}
      >
        <WidgetBody>
          <EventCalendar />
        </WidgetBody>
      </AgGridWidgetWrapper>
    </Container>
  );
};

export default ScheduledVisitComponent;
